import { fontAssets } from "@assets/fonts";
import { ImageAssets } from "@assets/images";
import { AnimationAssets } from "@assets/images/animation-assets";
import { Asset } from "expo-asset";
import { useEffect, useState } from "react";

function cacheImages(assets: string[], type: string) {
  return assets.map((image) => {
    return Asset.fromURI(image)
      .downloadAsync()
      .then(() => {
        console.log(`✅ Loaded ${type}:`, image);
      })
      .catch((err) => {
        console.log(`❌ FAILED ${type}:`, image);
        // throw err; // important
      });
  });
}

const usePreloadingHelper = () => {
  const [progress, setProgress] = useState(0);
  const totalAssets =
    ImageAssets.length +
    AnimationAssets.length +
    fontAssets.length;

  useEffect(() => {
    let loaded = 0;

    const updateProgress = () => {
      loaded++;
      setProgress((loaded / totalAssets) * 100);
    };

    const loadAssets = async () => {
      const imageAssets = cacheImages(ImageAssets, "IMAGE");
      const animationAssets = cacheImages(AnimationAssets, "ANIMATION");

      await Promise.allSettled([
        ...imageAssets.map(p => p.then(updateProgress)),
        ...animationAssets.map(p => p.then(updateProgress)),
        ...fontAssets.map(p => p.then(updateProgress)),
      ]);
    };

    loadAssets();
  }, []);

  return progress;
};

export default usePreloadingHelper;